import React, {useEffect} from 'react';
import Card from "@mui/material/Card";
import {
    Alert,
    Box,
    Button,
    CardActions,
    CardHeader,
    CircularProgress,
    LinearProgress,
    SvgIcon,
    Typography
} from "@mui/material";
import CardContent from "@mui/material/CardContent";
import localStrings from "../../localStrings";
import axios from "axios";
import useAuth from "../../hooks/useAuth";
import {LoadingButton} from "@mui/lab";
import useAppUtil from "../../hooks/useAppUtil";
import SyncIcon from '@mui/icons-material/Sync';
import {useSnackbar} from "notistack";
import toast from "react-hot-toast";
import moment from "moment";

const config = require("../../conf/config.json")

function SynchoEstablishmentItem({establishment, establishmentDb}) {

    const {currentBrand} = useAuth();
    const { addError } = useAppUtil();
    const [loading, setLoading] = React.useState(false);
    const [synchronizeOnGoing, setSynchronizeOnGoing] = React.useState(false);
    const [firstTrigger, setFirstTrigger] = React.useState(false);
    const { enqueueSnackbar } = useSnackbar();
    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function startImport() {
        setLoading(true);
        try {
            if (establishmentDb?.importOnGoing) {
                alert("stop");
                return;
            }

            const loadData = async () => {
                sleep(2000);
                await importArchive();
            }
            loadData();

            // const missingCount = await getAndFlagMissingArchiveUrl();
            // alert("missingCount " + missingCount);
            // if (missingCount === 0) {
            //     setSynchronizeOnGoing(true);
            // }
        }
        catch (error) {
            alert(error)
        }
        setLoading(false);
    }

    async function remoteStopImport() {
        // setLoading(true)
        const url = config.stopImportUrl + "/" + currentBrand().id + "/" + establishment.id
        try {
            const res = await axios.post(url,{},{
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': currentBrand().authKey
                }
            })
            return res.data.missingCount;
            // setPayments(res.data || []);
        }
        catch (error) {
            console.log(error);
            throw error;
        }
        finally {
            // setLoading(false);
        }
    }



    async function importArchive() {
        // setLoading(true)
        const url = config.importUrl + "/" + currentBrand().id + "/" + establishment.id
        try {
            const res = await axios.post(url,{},{
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': currentBrand().authKey
                }
            })
            return res.data.count;
            // setPayments(res.data || []);
        }
        catch (error) {
            console.log(error);
            throw error;
        }
        finally {
            // setLoading(false);
        }
    }

    function LinearProgressWithLabel(props) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <LinearProgress />
                {/*<Box sx={{ width: '100%', mr: 1 }}>*/}
                {/*    <LinearProgress variant="determinate" {...props} />*/}
                {/*</Box>*/}
                {/*<Box sx={{ minWidth: 35 }}>*/}
                {/*    <Typography variant="body2" color="text.secondary">{`${Math.round(*/}
                {/*        props.value,*/}
                {/*    )}%`}</Typography>*/}
                {/*</Box>*/}
            </Box>
        );
    }


    function getPercentValue() {
        if (!establishmentDb?.importedCount) {
            return 0;
        }
        return ( 100 * (establishmentDb?.importedCount) /
            (establishmentDb?.missingCount + establishmentDb?.importedCount));
    }

    return (
        <Card>
            {/*{establishmentDb?.importStepInfo && establishmentDb?.importStepInfo.length > 0 &&*/}
            {/*    <p>{establishmentDb?.importStepInfo}</p>*/}
            {/*}*/}
            <CardHeader title={establishment.name}>


            </CardHeader>
            <CardContent>

                <Box sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                }}>
                    {establishmentDb?.lastImportDate &&
                        <Box>
                            <Typography variant="body2" color="text.secondary" sx={{marginBottom: 5}}>
                                {localStrings.formatString(localStrings.lastUpdateDate,
                                    establishmentDb?.lastImportDate ?
                                        moment(establishmentDb?.lastImportDate).format('lll') : '-')}
                            </Typography>
                        </Box>
                    }
                    {establishmentDb?.importOnGoing &&
                    // {true &&
                        <>
                            <Box sx={{ display: 'flex' }}>
                                <Typography variant="body2" color="text.secondary">
                                    {localStrings.importOnGoing}
                                </Typography>
                            </Box>

                            <Box sx={{ display: 'flex' }}>
                                <CircularProgress />
                            </Box>
                        </>
                    }
                </Box>


            </CardContent>
            {/*<CardActions>*/}
            {/*    <div style={{width: '100%'}}>*/}
            {/*        <Box*/}
            {/*            sx={{*/}
            {/*                display: 'flex',*/}
            {/*                flexDirection: 'row-reverse',*/}
            {/*                p: 1,*/}
            {/*                m: 1,*/}
            {/*                borderRadius: 1,*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            <Box>*/}

            {/*                <LoadingButton*/}
            {/*                    loadingPosition="end"*/}
            {/*                    // loading={synchronizeOnGoing}*/}
            {/*                    onClick={async () => {*/}
            {/*                        if (establishmentDb?.importOnGoing) {*/}
            {/*                            await remoteStopImport();*/}
            {/*                        }*/}
            {/*                        else {*/}
            {/*                            await startImport();*/}
            {/*                        }*/}

            {/*                    }}*/}
            {/*                    variant="contained"*/}
            {/*                    color={establishmentDb?.importOnGoing ? "error" : "primary"}*/}
            {/*                    endIcon=*/}
            {/*                        {*/}
            {/*                            establishmentDb?.importOnGoing ?*/}
            {/*                                <CircularProgress disableShrink size={"25px"}/>*/}
            {/*                                :*/}
            {/*                                <SvgIcon>*/}
            {/*                                    <SyncIcon/>*/}
            {/*                                </SvgIcon>*/}
            {/*                        }*/}

            {/*                >*/}
            {/*                    {establishmentDb?.importOnGoing ? localStrings.stop : localStrings.synchronise}*/}
            {/*                </LoadingButton>*/}

            {/*                /!*<LoadingButton*!/*/}
            {/*                /!*    loadingPosition="start"*!/*/}
            {/*                /!*    loading={loading}*!/*/}
            {/*                /!*    onClick={() => startImport()}*!/*/}
            {/*                /!*    variant="contained">*!/*/}
            {/*                /!*    {localStrings.synchronise}*!/*/}
            {/*                /!*</LoadingButton>*!/*/}
            {/*            </Box>*/}
            {/*        </Box>*/}
            {/*    </div>*/}
            {/*</CardActions>*/}
            {/*<p>{establishmentDb?.importedCount}</p>*/}
        </Card>
    )
}

export default SynchoEstablishmentItem